import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectIsEventLive } from '../ducks/we-spin-dashboard-duck';
import useKeepAlive from '~/hooks/use-keep-alive';

const KeepAlive = () => {
	const { ping } = useKeepAlive();
	const isLive = useSelector(selectIsEventLive);

	useEffect(() => {
		const interval = setInterval(() => {
			if (isLive) {
				ping();
			}
		}, 30000);

		if (!isLive) {
			clearInterval(interval);
		}

		return () => clearInterval(interval);
	}, [isLive, ping]);

	return false;
};

export default KeepAlive;
